export default __webpack_public_path__ + "static/media/frax.c054cb36.svg";